import type { ClerkProviderProps } from "@clerk/react"

/** Clerk's account flows share the application's theme tokens (the shadcn-named aliases of HeroUI's variables in @anysola/ui/styles.css). */
export const clerkAppearance: ClerkProviderProps["appearance"] = {
  variables: {
    colorPrimary: "var(--primary)",
    colorPrimaryForeground: "var(--primary-foreground)",
    colorBackground: "var(--card)",
    colorInput: "var(--card)",
    colorInputForeground: "var(--foreground)",
    colorForeground: "var(--foreground)",
    colorMutedForeground: "var(--muted-foreground)",
    colorBorder: "var(--border)",
    colorDanger: "var(--destructive)",
    borderRadius: "var(--radius)",
    fontFamily: "var(--font-sans-family), sans-serif",
    fontFamilyMono: "var(--font-mono-family), monospace",
  },
  // Clerk's own card carries a drop shadow, a heavy border and a subtitle
  // ("Welcome back! Please sign in to continue") the title already says;
  // these bring it onto the site's flat, tone-separated surfaces.
  elements: {
    cardBox: "shadow-none! rounded-xl! border-0!",
    card: "bg-card! shadow-none! border-0!",
    footer: "bg-card! [background-image:none]!",
    headerSubtitle: "hidden!",
    // Literal colours: inside Clerk's tree `--border` and `--accent` resolve
    // to Clerk's own variables, not ours: `--border` drew a bright outline and
    // `--accent` turned the hovered button white under its white label.
    // The site's Grafit values, value for value: secondary button --default
    // (0.27) with the --border hairline, hover --default-hover (0.31); the
    // input filled like HeroUI's secondary field, with the --focus ring.
    socialButtonsBlockButton:
      "bg-[oklch(0.27_0.008_70)]! border-0! shadow-[inset_0_0_0_1px_oklch(0.29_0.008_70)]! hover:bg-[oklch(0.31_0.009_70)]!",
    formButtonPrimary:
      "bg-primary! text-primary-foreground! shadow-none! hover:bg-foreground!",
    formFieldInput:
      "bg-[oklch(0.27_0.008_70)]! shadow-none! focus:shadow-[0_0_0_2px_oklch(0.62_0.015_70)]!",
    // The sign-up consent box drew at 1.3:1 against the card.
    formFieldCheckboxInput:
      "border-[oklch(1_0_0/40%)]! shadow-[inset_0_0_0_1px_oklch(1_0_0/40%)]!",
  },
}
